import SimplePeer from "simple-peer";
import { PeerConfig } from "@/tools/config.js";

export default class RegularPrivate {
  constructor(data, roomID) {
    this.g = data;
    this.roomID = roomID;
    this.peer = new SimplePeer({
      initiator: false,
      trickle: true,
      config: PeerConfig
    });
    this.sockets();
  }
  init() {
    let object = {
      roomID: this.roomID,
      user: {
        username: this.g.user.username,
        avatar: this.g.user.avatar,
        id: this.g.user.id
      }
    };

    this.g.$socket.emit("viewer private regular join", object, result => {
      if (result.response == "not found") {
        this.g.$root.$alert("Error", "That room doesn't exist or isn't open.", {
          color: "red"
        });
        this.g.closeViewer();
      } else if (result.response == "not friends") {
        this.g.$root.$alert(
          "Error",
          "That person is not friends with you and they are hosting a private room.",
          { color: "red" }
        );
        this.g.closeViewer();
      } else if (result.response == "banned") {
        this.g.$root.$alert("Error", "You are banned from that room.", {
          color: "red"
        });
        this.g.closeViewer();
      } else if (result.response == "already in") {
        this.g.$root.$alert("Error", "You are already in that room.", {
          color: "red"
        });
        this.g.closeViewer();
      } else {
        console.log(result) //eslint-disable-line
        this.g.users = result.response.users;
        this.g.roomName = result.response.name;
        this.g.roomDescription = result.response.description;
        this.g.roomOwner = result.response.users[0];
        this.g.emoticons = result.response.emoticons;
      }
    });
  }
  sockets() {
    this.g.sockets.subscribe("viewer private regular join callback", signal => {
      this.peer.signal(signal);
    });

    this.g.sockets.subscribe("update users", users => {
      this.g.users = users;
      this.g.$emit("roomOwner", this.g.users[0]);
    });

    this.g.sockets.subscribe("update emoticons", emoticons => {
      this.g.emoticons = emoticons;
    });

    this.g.sockets.subscribe("room closed", () => {
      this.g.streaming = false;
      this.peer.destroy();
      this.peer = null;
      this.g.$emit("roomOwner", this.g.user);
      this.g.sockets.unsubscribe("viewer private regular join callback");
      this.g.sockets.unsubscribe("viewer private regular give host signal");
      this.g.sockets.unsubscribe("update users");
      this.g.sockets.unsubscribe("update emoticons");
      this.g.sockets.unsubscribe("room closed");
      this.g.sockets.unsubscribe("reconnect");
      this.g.sockets.unsubscribe("leave room");
      this.g.$root.$alert("Notice", "The room you were in has closed.");
      this.g.closeViewer();
    });

    this.g.sockets.subscribe("leave room", banned => {
      this.g.streaming = false;
      this.peer.destroy();
      this.peer = null;
      this.g.$emit("roomOwner", this.g.user);
      this.g.sockets.unsubscribe("viewer private regular join callback");
      this.g.sockets.unsubscribe("viewer private regular give host signal");
      this.g.sockets.unsubscribe("update users");
      this.g.sockets.unsubscribe("update emoticons");
      this.g.sockets.unsubscribe("room closed");
      this.g.sockets.unsubscribe("reconnect");
      this.g.sockets.unsubscribe("leave room");
      if (banned) {
        this.g.$root.$alert("Notice", "You have been banned.");
      } else {
        this.g.$root.$alert("Notice", "You have been kicked.");
      }
      this.g.closeViewer();
    });

    this.peer.on("signal", signal => {
      let object = {
        roomID: this.roomID,
        userID: this.g.user.id,
        signal: signal
      };
      this.g.$socket.emit("viewer private regular give host signal", object);
    });

    this.peer.on("stream", stream => {
      this.g.setStream(stream);
      this.g.privateRoom = false;
    });

    this.g.sockets.subscribe("reconnect", () => {
      if (this.g.streaming)
        this.g.$socket.emit("reconnection", {
          user: this.g.user,
          roomID: this.roomID
        });
    });
  }

  close(callback) {
    this.g.streaming = false;
    this.peer.destroy();
    this.peer = null;
    this.g.$emit("roomOwner", this.g.user);
    this.g.sockets.unsubscribe("viewer private regular join callback");
    this.g.sockets.unsubscribe("viewer private regular give host signal");
    this.g.sockets.unsubscribe("update users");
    this.g.sockets.unsubscribe("update emoticons");
    this.g.sockets.unsubscribe("room closed");
    this.g.sockets.unsubscribe("reconnect");
    this.g.sockets.unsubscribe("leave room");
    this.g.closeViewer(true);
    callback();
  }
}
